import { createSlice } from '@reduxjs/toolkit';
import { OrganizationWithPolicies } from '../../commonTypes/organization.types';
import { RootState } from '..';
import { restoreAll } from '../restoreAll';
import { removeUndefined } from '../../util/general';

export interface OrganizationState {
    value: OrganizationWithPolicies;
}

const initialState: OrganizationState = {
    value: {
        organizationId: '',
        name: '',
        website: '',
        phone: '',
        address: {
            city: '',
            countryId: '',
            streetline1: '',
            state: '',
            streetline2: '',
        },
        description: '',
        contactEmail: '',
        contactFullname: '',
        contactPhone: '',
        dateFormat: '',
        fax: '',
        policies: [],
        nonWorkingTimes: [],
        configuration: {
            customFields: [],
        },
        logoUrl: '',
        updatedAt: '',
        taxNumber: null,
        registrationNumber: null,
        taxNumberLabel: 'Tax Number',
        registrationNumberLabel: 'Registration Number',
    },
};

const organizationSlice = createSlice({
    name: 'organization',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        setOrganization: (state, action) => {
            state.value = action.payload;
        },
        editOrganization: (state, action) => {
            state.value = Object.assign(state.value, removeUndefined(action.payload));
        },
    },
});

export const { setOrganization, editOrganization } = organizationSlice.actions;

export const selectOrganization = (state: RootState) => state.organization.value;

export default organizationSlice.reducer;
